
    <template>
      <section class="relax-doc">
        <h1>Select 选择</h1>
<blockquote>
<p>下拉选择</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>使用 <code>v-model</code> 实现数据的双向绑定</p>
</blockquote>
<demo-block>
        <p><code>v-model</code> 的值是 <code>option</code> 的 <code>value</code> 值</p>

        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-select v-model=&quot;value&quot; placeholder=&quot;请选择&quot;&gt;
    &lt;x-option value=&quot;one&quot; label=&quot;options one&quot; /&gt;
    &lt;x-option value=&quot;two&quot; label=&quot;options two&quot; /&gt;
    &lt;x-option value=&quot;three&quot; label=&quot;options three&quot; /&gt;
    &lt;x-option value=&quot;four&quot; label=&quot;options four&quot; /&gt;
  &lt;/x-select&gt;
&lt;/template&gt;
&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const value = ref('')

      return {
        value
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="jin-yong-xuan-xiang"><a class="header-anchor" href="#jin-yong-xuan-xiang"></a> 禁用选项</h2>
<blockquote>
<p>给 <code>option</code> 组件添加 <code>disabled</code> 可以禁止选项</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-select v-model=&quot;value&quot; placeholder=&quot;请选择&quot;&gt;
    &lt;x-option value=&quot;one&quot; label=&quot;options one&quot; /&gt;
    &lt;x-option value=&quot;two&quot; label=&quot;options two&quot; /&gt;
    &lt;x-option value=&quot;three&quot; label=&quot;options three&quot; disabled /&gt;
    &lt;x-option value=&quot;four&quot; label=&quot;options four&quot; disabled/&gt;
  &lt;/x-select&gt;
&lt;/template&gt;
&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const value = ref('one')

      return {
        value
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="duo-xuan"><a class="header-anchor" href="#duo-xuan"></a> 多选</h2>
<blockquote>
<p>给 <code>option</code> 组件添加 <code>disabled</code> 可以禁止选项</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-select v-model=&quot;value&quot; placeholder=&quot;请选择&quot;&gt;
    &lt;x-option value=&quot;one&quot; label=&quot;One&quot; /&gt;
    &lt;x-option value=&quot;two&quot; label=&quot;Two&quot; /&gt;
    &lt;x-option value=&quot;three&quot; label=&quot;Three&quot; disabled /&gt;
    &lt;x-option value=&quot;four&quot; label=&quot;Four&quot; /&gt;
  &lt;/x-select&gt;
&lt;/template&gt;
&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const value = ref(['one'])

      return {
        value
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="sou-suo-wei-du"><a class="header-anchor" href="#sou-suo-wei-du"></a> 搜索维度</h2>
<blockquote>
<p>添加 <code>search</code> 属性将开启搜索，</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo3 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-select v-model=&quot;value&quot; placeholder=&quot;请选择&quot; :search=&quot;true&quot;&gt;
    &lt;x-option value=&quot;one&quot; label=&quot;One&quot; /&gt;
    &lt;x-option value=&quot;two&quot; label=&quot;Two&quot; /&gt;
    &lt;x-option value=&quot;three&quot; label=&quot;Three&quot;  disabled /&gt;
    &lt;x-option value=&quot;four&quot; label=&quot;Four&quot;  /&gt;
  &lt;/x-select&gt;
&lt;/template&gt;
&lt;script&gt;
  import {ref} from 'vue'
  export default {
    setup(){
      const value = ref([])

      return {
        value
      }
    }
  }
&lt;/script&gt;
</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_option = _resolveComponent("x-option")
  const _component_x_select = _resolveComponent("x-select")

  return (_openBlock(), _createBlock(_component_x_select, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event),
    placeholder: "请选择"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_x_option, {
        value: "one",
        label: "options one"
      }),
      _createVNode(_component_x_option, {
        value: "two",
        label: "options two"
      }),
      _createVNode(_component_x_option, {
        value: "three",
        label: "options three"
      }),
      _createVNode(_component_x_option, {
        value: "four",
        label: "options four"
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const value = ref('')

      return {
        value
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_option = _resolveComponent("x-option")
  const _component_x_select = _resolveComponent("x-select")

  return (_openBlock(), _createBlock(_component_x_select, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event),
    placeholder: "请选择"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_x_option, {
        value: "one",
        label: "options one"
      }),
      _createVNode(_component_x_option, {
        value: "two",
        label: "options two"
      }),
      _createVNode(_component_x_option, {
        value: "three",
        label: "options three",
        disabled: ""
      }),
      _createVNode(_component_x_option, {
        value: "four",
        label: "options four",
        disabled: ""
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const value = ref('one')

      return {
        value
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_option = _resolveComponent("x-option")
  const _component_x_select = _resolveComponent("x-select")

  return (_openBlock(), _createBlock(_component_x_select, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event),
    placeholder: "请选择"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_x_option, {
        value: "one",
        label: "One"
      }),
      _createVNode(_component_x_option, {
        value: "two",
        label: "Two"
      }),
      _createVNode(_component_x_option, {
        value: "three",
        label: "Three",
        disabled: ""
      }),
      _createVNode(_component_x_option, {
        value: "four",
        label: "Four"
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const value = ref(['one'])

      return {
        value
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, withCtx: _withCtx, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_option = _resolveComponent("x-option")
  const _component_x_select = _resolveComponent("x-select")

  return (_openBlock(), _createBlock(_component_x_select, {
    modelValue: _ctx.value,
    "onUpdate:modelValue": $event => ((_ctx.value) = $event),
    placeholder: "请选择",
    search: true
  }, {
    default: _withCtx(() => [
      _createVNode(_component_x_option, {
        value: "one",
        label: "One"
      }),
      _createVNode(_component_x_option, {
        value: "two",
        label: "Two"
      }),
      _createVNode(_component_x_option, {
        value: "three",
        label: "Three",
        disabled: ""
      }),
      _createVNode(_component_x_option, {
        value: "four",
        label: "Four"
      })
    ]),
    _: 1
  }, 8, ["modelValue", "onUpdate:modelValue"]))
}
  
    
        const {ref} = Vue
        
  const democomponentExport = {
    setup(){
      const value = ref([])

      return {
        value
      }
    }
  }
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  